module.exports = __webpack_public_path__ + "img/bin.ba727d33.svg";